import BaseService from "../../services/BaseService";

class SubscriptionAccessesService extends BaseService {}

export default new SubscriptionAccessesService('health_backend', 'subscription_accesses');